import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { AgentPacksSection } from '../agent-packs/AgentPacksSection';
import { SingleSkeletonLoader } from '../loading/SingleSkeletonLoader';
import { FSC_INCLUDED_PACK_ID, FSC_OTHER_PACK_ID } from './fscCreditPacksHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/* Keyed by the preset pack size so i18n keys stay string literals at the call
 * site (the static analyzer requires that) and there's no unreachable branch. */
const PRESET_PACK_LABELS = {
  SMALL: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "agentPacksComponents.packLabels.starter"
  }),
  MEDIUM: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "agentPacksComponents.packLabels.professional"
  }),
  LARGE: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "agentPacksComponents.packLabels.enterprise"
  })
};
const CreditPacksCardSkeleton = () => /*#__PURE__*/_jsx(CardWrapper, {
  inlineSize: "100%",
  padding: "600",
  children: /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "400",
    "aria-hidden": true,
    children: [/*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 20,
      width: "180px"
    }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 16
    }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 16
    }), /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 16
    })]
  })
});
export const FscCreditPacksCard = ({
  status
}) => {
  if (status.type === 'pageLoading') {
    return /*#__PURE__*/_jsx(CreditPacksCardSkeleton, {});
  }
  const card = status.data;

  /* "Current" only for a non-upgrade portal that owns credits; upgrades and free portals read "Included". */
  const includedOption = {
    type: 'included',
    id: FSC_INCLUDED_PACK_ID,
    label: card.showCurrentLabel ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "agentPacksComponents.packLabels.current"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "agentPacksComponents.packLabels.included"
    })
  };
  const paidOptions = card.presetPacks.map(pack => ({
    type: 'paid',
    id: pack.id,
    label: PRESET_PACK_LABELS[pack.creditPackSize],
    credits: pack.credits,
    pricePerMonth: pack.pricePerMonth,
    isRecommended: pack.isRecommended
  }));
  const customOption = {
    type: 'custom',
    id: FSC_OTHER_PACK_ID,
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "agentPacksComponents.packLabels.other"
    })
  };
  return /*#__PURE__*/_jsx(AgentPacksSection, {
    packs: [includedOption, ...paidOptions, customOption],
    includedCredits: card.includedCredits,
    currentCredits: card.currentCredits,
    additionalOwnedCredits: card.additionalOwnedCredits,
    selectedPackId: card.selectedPackId,
    currencyCode: card.currencyCode,
    initiallyExpanded: false
    /* The "+" sign marks credits added to the current total, so it's off on the upgrade path's projected "Total". */,
    showAdditionalPriceSign: card.additionalOwnedCredits === undefined,
    collapsedShowsCurrentOnly: true,
    viewRateDetailsUrl: card.viewRateDetailsUrl,
    onViewRateDetails: card.onViewRateDetails,
    onPackSelect: card.onSelectPack,
    onToggleExpand: card.onToggleExpand,
    customMonthlyCost: card.custom.monthlyCost,
    customCredits: card.custom.credits,
    customStepSize: card.custom.stepSize,
    customMaxMonthlyCost: card.custom.maxMonthlyCost,
    customDisabled: card.custom.disabled,
    onCustomAmountStep: card.onCustomAmountStep,
    onCustomAmountCommit: card.onCustomAmountCommit
  });
};